export default "__VITE_ASSET__CSi6RxqV__"